import { useCallback } from 'react';
import { db } from '../data/storage';
import { cacheManager } from '../data/cacheManager';
import type { Weight } from '../data/types';

export function useWeights() {
    // Optimistic add weight
    const addWeight = useCallback(async (weight: Weight) => {
        const syncId = `weight-add-${weight.id}`;

        // 1. Update cache immediately (optimistic)
        cacheManager.updateCacheOptimistically('weight', 'add', weight);

        // 2. Mark as pending sync
        cacheManager.addPendingSync({
            id: syncId,
            type: 'weight',
            operation: 'add',
            data: weight,
        });

        // 3. Sync to IndexedDB (background)
        try {
            await db.addWeight(weight);
            cacheManager.removePendingSync(syncId);
        } catch (error) {
            console.error('Failed to add weight:', error);
            // Will retry on next app load
        }
    }, []);

    return {
        addWeight,
    };
}